// today
const minDateNow = () => {
  let beforedate = new Date()
  let priordate = new Date()
  priordate.setDate(beforedate.getDate() + 2)
  let dd2 = priordate.getDate()
  let mm2 = priordate.getMonth() + 1
  let yyyy2 = priordate.getFullYear()
  if (dd2 < 10) { dd2 = '0' + dd2 };
  if (mm2 < 10) { mm2 = '0' + mm2 };
  let datefrommonthago = yyyy2 + '-' + mm2 + '-' + dd2

  return datefrommonthago
}
export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  moving: {
    tower_id: null,
    unit_id: null,
    go_in_out: null,
    type: null,
    status: true,
    _lock_go_in_out: false
  },
  movings: [],
  entity: 'moving',
  entities: 'movings',
  dwellerUnits: [],
  dwellerTowers: [],
  optionType: [
    {
      id: 'in',
      label: 'Entrada'
    },
    {
      id: 'out',
      label: 'Saida'
    }
  ],
  optionStatus: [
    {
      id: true,
      label: 'Ativo'
    },
    {
      id: false,
      label: 'Inativo'
    }
  ],
  miniDate: minDateNow(),
  prefixRouter: 'dweller.moving'
})



// WEBPACK FOOTER //
// ./src/app/dweller/moving/resources/data.js